import { gql } from '@apollo/client';

const GET_CAMPAIGNS_QUERY = gql`
  query CampaignFindMany($filter: FilterFindManyCampaignInput, $limit: Int) {
    CampaignFindMany(filter: $filter, limit: $limit) {
      ad_settings
      affiliates
      remote_campaign_status
      enabled
      events {
        enabled
        _id
        event
      }
      adsSummary {
        pending
        approved
        rejected
        lastUpdate
      }
      rotation {
        name
        _id
      }
      name
      nickname
      _id
      status
      group
      vertical {
        _id
        name
      }
      lastCostUpdate {
        clicks
        spent
        conversions
      }
      media_buyer {
        firstName
        lastName
        _id
      }
      rotation {
        _id
        name
      }
      url
      schedule {
        type
        enabled
        managed_by_traffic_source
        start_date
        end_date
        initialized
        time_zone {
          default_value
          isDST
          moment_name
          text
        }

        days {
          friday {
            all_day
            cpc_adjustment
            enabled
            from
            hour_from
            hour_to
            minute_from
            minute_to
            removed
            to
          }
          monday {
            all_day
            cpc_adjustment
            enabled
            from
            hour_from
            hour_to
            minute_from
            minute_to
            removed
            to
          }
          saturday {
            all_day
            cpc_adjustment
            enabled
            from
            hour_from
            hour_to
            minute_from
            minute_to
            removed
            to
          }
          sunday {
            all_day
            cpc_adjustment
            enabled
            from
            hour_from
            hour_to
            minute_from
            minute_to
            removed
            to
          }
          thursday {
            all_day
            cpc_adjustment
            enabled
            from
            hour_from
            hour_to
            minute_from
            minute_to
            removed
            to
          }
          tuesday {
            all_day
            cpc_adjustment
            enabled
            from
            hour_from
            hour_to
            minute_from
            minute_to
            removed
            to
          }
          wednesday {
            all_day
            cpc_adjustment
            enabled
            from
            hour_from
            hour_to
            minute_from
            minute_to
            removed
            to
          }
        }
      }
      remote {
        budgets {
          daily {
            pacing
            amount
            warned
            alerted
          }
          monthly {
            amount
            warned
            alerted
          }
          notifyTo
          percentage_alert
        }
      }

      remoteCampaign
      remoteSettings
      remote_campaign
      cpc
      consecutive_in_traffic_source
      trafficSource {
        _id
        accounts
        api {
          name
        }
        api_functionality{
          multiple_ad_groups_supported
        }
        shortname
        logo
        events {
          _id
          account
        }
      }
      created_on
      tokens
      tracking_domain
      url
      targetROI
      automations {
        _id
        enabled
        automation
      }
      automations_automation {
        _id
        name
        type
        enabled
        behavior {
          notifyTo
          type
        }
        configuration {
        _id
        affectedPlacements
        budget {
          adjustmentType
          adjustmentValue
          budgetLimit
          budgetLimitEnabled
          budgetUtilization
          conditionGroups {
            conditions {
              logicalOperator
              metric
              operator
              order
              timeframe
              value
            }
            logicalOperator
            order
          }
          enabled
          order
          type
        }
        status{
          enabled
          order
          type
          conditionGroups {
            conditions {
              logicalOperator
              metric
              operator
              order
              timeframe
              value
            }
            logicalOperator
            order
          }
        }
        dateRange {
          includeToday
        }
        limits {
          sortDirection
        }
        roi {
          enableMinMax
        }
        protection {
          dateRange {
            includeToday
          }
          enabled
        }
      }
        group {
        _id
       }
        cron
      }
    }
  }
`;

const GET_CAMPAIGNS_WITH_AUTOMATIONS_QUERY = gql`
  query CampaignFindManyWithAutomations($filter: FilterFindManyCampaignInput) {
    CampaignFindMany(filter: $filter) {
      _id
      name
      nickname
      automations_automation {
        _id
        name
        type
        enabled
        behavior {
          notifyTo
          type
        }
        configuration {
          _id
          affectedPlacements
          budget {
            adjustmentType
            adjustmentValue
            budgetLimit
            budgetLimitEnabled
            budgetUtilization
            conditionGroups {
              conditions {
                logicalOperator
                metric
                operator
                order
                timeframe
                value
              }
              logicalOperator
              order
            }
            enabled
            order
            type
          }
          status {
            enabled
            order
            type
            conditionGroups {
              conditions {
                logicalOperator
                metric
                operator
                order
                timeframe
                value
              }
              logicalOperator
              order
            }
          }
          dateRange {
            includeToday
          }
          limits {
            sortDirection
          }
          roi {
            enableMinMax
          }
          protection {
            dateRange {
              includeToday
            }
            enabled
          }
        }
        group {
          _id
        }
        cron
      }
    }
  }
`;

export const CampaignsGqlService = {
  queries: {
    GET_CAMPAIGNS_QUERY,
    GET_CAMPAIGNS_WITH_AUTOMATIONS_QUERY,
  },
};
